<template>
  <div >
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4 col-xl mb-2 mb-xl-0">
            <b-link class="media" @click="goTo(0)">
              <div class="media-aside mr-2 align-self-start">
                <span
                  class="b-avatar badge-light-primary rounded-circle"
                  style="width: 48px; height: 48px"
                  ><span class="b-avatar-custom">
                    <feather-icon icon="BookOpenIcon" size="21" />
                  </span>
                </span>
              </div>
              <div class="media-body my-auto">
                <h4 class="font-weight-bolder mb-0">المقررات</h4>
                <p class="card-text font-small-3 mb-0 text-secondary">
                  والمناهج
                </p>
              </div>
            </b-link>
          </div>
       
          <div class="col-sm-4 col-xl mb-2 mb-xl-0">
            <b-link class="media" @click="goTo(1)">
              <b-link class="media-aside mr-2 align-self-start">
                <span
                  class="b-avatar badge-light-info rounded-circle"
                  style="width: 48px; height: 48px"
                  ><span class="b-avatar-custom"
                    ><feather-icon icon="Edit2Icon" size="21" /></span
                  ><!----></span
                >
              </b-link>
              <div class="media-body my-auto">
                <h4 class="font-weight-bolder mb-0">التدريبات</h4>
                <!-- <p class="card-text font-small-3 mb-0">Customers</p> -->
              </div>
            </b-link>
          </div>
          <div class="col-sm-4 col-xl mb-2 mb-sm-0">
            <b-link class="media" @click="goTo(2)">
              <div class="media-aside mr-2 align-self-start">
                <span
                  class="b-avatar badge-light-danger rounded-circle"
                  style="width: 48px; height: 48px"
                  ><span class="b-avatar-custom">
                    <feather-icon icon="ClipboardIcon" size="21" /> </span
                  ><!----></span
                >
              </div>
              <div class="media-body my-auto">
                <h4 class="font-weight-bolder mb-0">الاختبارات</h4>
                <!-- <p class="card-text font-small-3 mb-0">Products</p> -->
              </div>
            </b-link>
          </div>
          <div class="col-sm-4 col-xl mb-2 mb-xl-0">
            <b-link href="" class="media" :to="{ name: 'FileSystem' }">
              <div class="media-aside mr-2 align-self-start">
                <span
                  class="b-avatar badge-light-primary rounded-circle"
                  style="width: 48px; height: 48px"
                  ><span class="b-avatar-custom">
                    <feather-icon icon="BriefcaseIcon" size="21" /> </span
                  ><!----></span
                >
              </div>
              <div
                class="media-body my-auto"
                v-if="user.account_type == 'student'"
              >
                <h4 class="font-weight-bolder mb-0">حقيبة</h4>
                <p class="card-text font-small-3 mb-0 text-secondary">الطالب</p>
              </div>
              <div
                class="media-body my-auto"
                v-if="user.account_type == 'teacher'"
              >
                <h4 class="font-weight-bolder mb-0">حقيبة</h4>
                <p class="card-text font-small-3 mb-0 text-secondary">المعلم</p>
              </div>
            </b-link>
          </div>
          <div class="col-sm-4 col-xl mb-2 mb-xl-0">
            <b-link class="media" :to="{ name: 'LibrarySearch' }">
              <div class="media-aside mr-2 align-self-start">
                <span
                  class="b-avatar badge-light-info rounded-circle"
                  style="width: 48px; height: 48px"
                  ><span class="b-avatar-custom">
                    <feather-icon icon="BookIcon" size="21" /> </span
                  ><!----></span
                >
              </div>
              <div class="media-body my-auto">
                <h4 class="font-weight-bolder mb-0">المكتبة</h4>
                <p class="card-text font-small-3 mb-0 text-secondary">
                  الرقمية
                </p>
              </div>
            </b-link>
          </div>
		            <div class="col-sm-4 col-xl mb-2 mb-xl-0">
            <b-link class="media" :to="{ name: 'DownloadExcel' }">
              <div class="media-aside mr-2 align-self-start">
                <span
                  class="b-avatar badge-light-info rounded-circle"
                  style="width: 48px; height: 48px"
                  ><span class="b-avatar-custom">
                    <feather-icon icon="BookIcon" size="21" /> </span
                  ><!----></span
                >
              </div>
              <div class="media-body my-auto">
                <h4 class="font-weight-bolder mb-0">تنزيل</h4>
                <p class="card-text font-small-3 mb-0 text-secondary">
                  سجل الطالب
                </p>
              </div>
            </b-link>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-enter-active">
      <b-col lg="4" class="draggable-zone">
        <draggable
          handle=".handle"
          tag="div"
          group="data"
          :list="right"
          @change="afterAdd"
        >
          <component
            v-for="(item, index) in right"
            v-bind:is="item.type"
            :key="index"
            v-bind="item.props"
            @drop="drop()"
          >
          </component>
        </draggable>
      </b-col>

      <!-- Big SIde && left side  -->
      <b-col lg="8" class="draggable-zone">
        <span id="draggable-zone-2-starter" />
        <draggable handle=".handle" group="data" :list="left" tag="div">
          <component
            v-for="(item, index) in left"
            v-bind:is="item.type"
            :key="index"
            v-bind="item.props"
            @change="afterAdd"
          >
          </component>
        </draggable>
      </b-col>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HomeController from "../../../Controllers/HomeController";
import User from "./components/User.vue";
import Guide from "./components/Guide.vue";
import MyEdProgram from "./components/MyEdProgram.vue";
import MyTask from "./components/MyTask.vue";
import Schedule from "./components/Schedule.vue";
import Announcement from "./components/Announcement.vue";
import CurrentEventsVue from "./components/CurrentEvents.vue";
import StatisticsVue from "./components/Statistics.vue";
import Auth from "@/Apis/Auth";
import CompletionPercentage from "./components/CompletionPercentage.vue";
import CardAdvanceEmployeeOnLine from "./components/CardAdvanceEmployeeOnLine.vue";
import StatisticCardVertical from "./components/StatisticCardVertical.vue";
import draggable from "vuedraggable";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

export default {
  name: "Home",
  components: {
    User,
    Guide,
    MyEdProgram,
    MyTask,
    Schedule,
    Announcement,
    CurrentEventsVue,
    StatisticsVue,
    CompletionPercentage,
    CardAdvanceEmployeeOnLine,
    StatisticCardVertical,
    Prism,
    draggable,
  },
  data() {
    return {
      user: {},
      eduPrograms: {},
      announcement: {},
      polls: {},
      toDo: [],
      eduProgram: {},
      statistics: {},
      currentEvents: {},
      master: {},
      right: [],
      left: [],
     };
  },
  async created() {
    // Auth.connectLogIN();
    this.eduProgram = localStorage.getItem("eduProgram");
    this.user = Auth.USER;
    this.master = localStorage.getItem("master");

    let setting = JSON.parse(localStorage.getItem("setting"));

    if (this.user.account_type != "admin" && !this.master) {
      const data = await new HomeController().StudentHome(this.eduProgram);
      this.eduPrograms = Auth.EDU_PROGRAMS;
      this.announcement = data.announcements;
      this.polls = data.polls;
      this.toDo = data.toDo;
      this.statistics = data.programStatistics;
      this.currentEvents = data.currentEvents;
      if (setting == null) {
        this.left = [
          {
            type: "announcement",
            id: 1,
            props: {
              items: this.announcement,
              title: this.$i18n.t("announcements.announcements"),
              type: "announcement",
            },
          },
          {
            type: "announcement",
            id: 2,
            props: {
              items: this.polls,
              title: this.$i18n.t("polls.polls"),
              type: "poll",
            },
          },
          {
            type: "StatisticsVue",
            id: 3,
            props: { data: this.statistics },
          },
          {
            type: "CurrentEventsVue",
            id: 4,
            props: null,
          },
        ];

        this.right = [
          {
            type: "User",
            id: 1,
            props: {
              user: this.user,
            },
          },
          // {
          //   type: "Guide",
          //   id: 2,
          //   props: {
          //     user: this.user,
          //   },
          // },
          {
            type: "CardAdvanceEmployeeOnLine",
            id: 3,
            props: null,
          },
          {
            type: "CompletionPercentage",
            id: 4,
            props: null,
          },
          {
            type: "MyTask",
            id: 5,
            props: { items: this.toDo },
          },
        ];
      } else {
        setting.left.forEach((element) => {
          this.setComponentsData(element);
        });
        setting.right.forEach((element) => {
          this.setComponentsData(element);
        });
        this.left = setting.left;
        this.right = setting.right;
      }
    }
  },
  methods: {
    setComponentsData(element) {
      switch (element.type) {
        case "announcement":
          if (element.id == 1) {
            element.props = {
              items: this.announcement,
              title: this.$i18n.t("announcements.announcements"),
              type: "announcement",
            };
          } else {
            element.props = {
              items: this.polls,
              title: this.$i18n.t("polls.polls"),
              type: "poll",
            };
          }
          break;

        case "StatisticsVue":
          element.props = { data: this.statistics };
          break;
        case "User":
          element.props = {
            user: this.user,
          };
          break;
        case "MyTask":
          element.props = {
            items: this.toDo,
          };
          break;
      }
    },
    goTo: function (type) {
      localStorage.setItem("courseType", type);

      this.$router.push({
        name: "Courses",
        params: { eduProgramId: this.eduProgram },
      });
    },
    afterAdd(evt) {
      console.log(this.right, this.right);
    },
    // handleChange() {
    //   console.log(this.right,this.right);
    //   localStorage.setItem(
    //     "setting",
    //     `{"user":${Auth.USER.id},"right":${JSON.stringify(
    //       this.right.map((obj) => {
    //         return { type: obj.type, id: obj.id };
    //       })
    //     )},"left":${JSON.stringify(
    //       this.left.map((obj) => {
    //         return { type: obj.type, id: obj.id };
    //       })
    //     )}}`
    //   );
    // },

    // getComponentData() {
    //   return {
    //     on: {
    //       change: this.handleChange,
    //     },
    //   };
    // },
  },
};
</script>

